window.addEventListener('load', function() {
    const _throttle = require('lodash.throttle');

    // Store style elements for cleanup
    const tickerStyles = new WeakMap();

    function initializeTicker(tickerContainer) {
        const animatedTickers = tickerContainer.querySelectorAll('.animate-ticker-x');
        if (animatedTickers.length === 0) return;

        const ticker = animatedTickers[0];

        // Hide second ticker - only need one with duplicated content
        if (animatedTickers[1]) {
            animatedTickers[1].style.display = 'none';
        }

        // Clean up previous style element
        const prevStyle = tickerStyles.get(tickerContainer);
        if (prevStyle) prevStyle.remove();

        // Stop animation for measurement
        ticker.style.animation = 'none';
        void ticker.offsetWidth;

        // Measure distance to halfway point (items 1-10 are duplicated as 11-20)
        const items = ticker.querySelectorAll(':scope > .flex');
        if (items.length < 2) return;

        const halfCount = Math.floor(items.length / 2);
        const translateDistance = items[halfCount].offsetLeft - items[0].offsetLeft;

        // Get speed from data attribute or default to 20
        const dataSpeed = parseFloat(tickerContainer.dataset.tickerSpeed);
        const speed = dataSpeed > 0 ? dataSpeed : 20;
        const duration = translateDistance / speed;

        // Create keyframes
        const animationName = `ticker-${Math.random().toString(36).slice(2, 9)}`;
        const styleEl = document.createElement('style');
        styleEl.textContent = `
            @keyframes ${animationName} {
                from { transform: translateX(0); }
                to { transform: translateX(-${translateDistance}px); }
            }
        `;
        document.head.appendChild(styleEl);
        tickerStyles.set(tickerContainer, styleEl);

        // Apply animation
        ticker.style.animation = `${animationName} ${duration}s linear infinite`;
    }

    // Initialize ticker after loading all its SVGs
    function initializeTickerWithSVGs(tickerContainer) {
        // Force load all SVGs in this ticker first, then initialize
        if (window.loadAllSVGsIn) {
            window.loadAllSVGsIn(tickerContainer).then(function() {
                initializeTicker(tickerContainer);
            });
        } else {
            initializeTicker(tickerContainer);
        }
    }

    function initializeAllTickers() {
        document.querySelectorAll('.ticker-panel').forEach(initializeTickerWithSVGs);
    }

    // Initialize on load
    initializeAllTickers();

    // Reinitialize on resize
    window.addEventListener('resize', _throttle(initializeAllTickers, 300));
});
